import React, { ReactNode } from 'react';
import { Field } from '..';

type Props = {
  when: string;
  is: string;
  children: ReactNode;
};

const Condition = ({ when, is, children }: Props) =>
  is.split('|').map((condition) => (
    <Field key={condition} name={when} subscription={{ value: true }}>
      {({ input: { value } }) => (value === condition ? children : null)}
    </Field>
  ));

export default Condition;
